import { Component } from '@angular/core';

@Component({
  selector: 'now-wbsuche-lib-kontakt-avatar',
  templateUrl: './unisex_avatar.svg'
})
export class KontaktAvatarComponent {}
